export default __webpack_public_path__ + "static/media/64.5bd7221b.svg";